import entityFactory from 'services/entity-factory';
import requestQuoteBundle from 'services/entity-factory/requestQuoteBundle';
import Form from 'services/validation/Form';

export function buildForm(validations)
{
    return new Form(entityFactory(requestQuoteBundle), validations);
}
